export const getProductTypeId = (formValues) =>
  formValues?.productSnapShot?.type?._id ??
  formValues?.productSnapShot?.type ??
  formValues?.product?.type?._id ??
  formValues?.product?.type;

export const buildConsultantLicenceErrorMessage = (unlicensedNames, t) =>
  t("Consultant {{names}} does not have the required licence for this product type", {
    names: unlicensedNames.join(", "),
  });
